/* eslint-disable */
import testRunStatusReducer from "../testRunStatusReducer";
import testRunStatusRevisedReducerCloseLoop from "./testRunStatusRevisedReducerCloseLoop";

const defaultStatusData = {
    testRunStatus: [],
    pages: [],
    currentPage: 0
};
//     const edit_api_url = (window.location.origin).concat('/edit')
//     const data_for_api = {
//         scenario_uuid : submitValue['scenario_uuid'],
//         scenario_description : submitValue['scenario_name']
//     }
//     editDb(edit_api_url, data_for_api).then(res => {
//         console.log("Status of updation : ", res['data']['status'])
//         if(res['data']['status'] === "Updated Successfully"){
//             this.props.dispatch(editScenarioGroupData(submitValue));
//             this.props.handleEditModalClose();
//         }


const testRunStatusReducerCloseLoop = (state = defaultStatusData, action) => {
    switch(action.type) {
        case 'ADD_TESTRUN_STATUS_FROM_API':
            return {
                testRunStatus: action.testRunStatus,
                currentPage: action.currentPage,
                pages: action.pages
            }
        default:
            return state
    }
}

export default testRunStatusReducerCloseLoop
